import React, { useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import { Link } from 'react-router-dom';

const TabsData = ({ module, section = "notefall1", newTabs=false }) => {
    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
        const equalHeight = () => {
            // 👉 H4 elements
            const headings = document.querySelectorAll(
                ".tab-content .col-inner h4"
            );

            let maxH4 = 0;
            headings.forEach((el) => {
                el.style.height = "auto";
                maxH4 = Math.max(maxH4, el.offsetHeight);
            });
            headings.forEach((el) => {
                el.style.height = maxH4 + "px";
            });

        };

        // run on load
        setTimeout(equalHeight, 100);
        // run on resize
        window.addEventListener("resize", equalHeight);
        return () => {
            window.removeEventListener("resize", equalHeight);
        };
    }, [activeTab]);

    return (
        <section className={`pb-10 ${section === "notefall" ? "sec-orange-color" : "sec-pink-color"} sec-zahlen-fakten`}>
            <div className='container'>
                <div className={`tab_wrapper notefall_tabs ${newTabs ? 'portraet_notefall_tabs' : ''} mt-4 mt-lg-5`}>
                    <ul className="nav nav-tabs">
                        {module.Modul.map((tab, index) => (
                            <li className="nav-item" key={tab.id}>
                                <button
                                    className={`nav-link ${activeTab === index ? "active" : ""}`}
                                    onClick={() => setActiveTab(index)}
                                >
                                    {tab.Titel}
                                </button>
                            </li>
                        ))}
                    </ul>
                    <div className="tab-content mt-4 mt-lg-5">
                        {module.Modul.map((tab, index) => (
                            activeTab === index && (
                                <div className="tab-pane active" key={tab.id}>
                                    <div className={`${section === "notefall" ? "notefall-row" : "zahlen-row"}`}>

                                        {section === "notefall" ? (
                                            tab.Modul.map((item) => (
                                                <div className='col-item' key={item.id}>
                                                    <div className='col-inner text-center'>
                                                        <img
                                                            src={`https://backend.bgzurlinden.ch${item.Icon?.url}`}
                                                            className='item-icon'
                                                            alt={item.Icon?.alternativeText || "icon"}
                                                        />
                                                        <h4 className='fs_24 text-darkgrey fw-550 mb-2 mt-2'>{item.Titel}</h4>
                                                        <Link className='text-orange' to={`tel:${item.telephone_number}`}>{item.telephone_number}</Link>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            tab.Modul.map((item) => (
                                                <div className='col-item' key={item.id}>
                                                    <div className='col-inner text-center'>
                                                        <img
                                                            src={`https://backend.bgzurlinden.ch${item.Icon?.url}`}
                                                            className='item-icon'
                                                            alt={item.Icon?.alternativeText || "icon"}
                                                        />
                                                        <h2 lang='de' className='text-darkgrey fw-550 mb-2 mt-3'>
                                                            {item.Titel}
                                                        </h2>
                                                        <p lang='de' className='fw-500'>
                                                            {item.telephone_number}
                                                        </p>
                                                    </div>
                                                </div>
                                            ))
                                        )
                                        }


                                    </div>
                                </div>
                            )
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default TabsData